


















import { Vue, Prop, Component } from 'vue-property-decorator';
import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-blue-text.svg';

@Component({
  components: {
    GetAcceptLogo,
  },
})
export default class TopBar extends Vue {
  @Prop() logo?: string;
}
